export default __webpack_public_path__ + "static/media/portfolio-midios-1.a22630ad.png";